import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import { namespaces } from '@/shared/lib/i18n/locales'
import { resources } from '@/shared/lib/i18n/resources'

export const defaultNS = 'common'

i18n.use(initReactI18next).init({
  lng: 'pt-BR',
  fallbackLng: 'pt-BR',
  ns: namespaces,
  defaultNS,
  resources,
  interpolation: { escapeValue: false },
})

export default i18n
